import React from "react";

const SimpleLoader = ({ 
  text = "Loading...", 
  size = "medium",
  className = "" 
}) => {
  const sizeClasses = {
    small: "w-6 h-6",
    medium: "w-12 h-12", 
    large: "w-16 h-16"
  };

  return (
    <div className={`flex flex-col items-center justify-center space-y-4 ${className}`}>
      <div className={`${sizeClasses[size]} border-4 border-gray-200 border-t-emerald-600 rounded-full animate-spin`}></div>
      {text && (
        <p className="text-sm font-medium text-gray-600">{text}</p>
      )}
    </div>
  );
};

export default SimpleLoader; 